// Generated by CoffeeScript 1.12.5
var dasherize, key, sites;

module.exports = sites = {
  'garbanzoApi': {
    development: {
      protocol: 'http',
      uri: 'api.goodeggs.test',
      port: 3000
    },
    test: {
      protocol: 'http',
      uri: 'api.goodeggs.test',
      port: 3001
    },
    staging: {
      protocol: 'https',
      uri: 'api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'api.goodeggs.com'
    }
  },
  'manage': {
    development: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3010
    },
    test: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3011
    },
    staging: {
      protocol: 'https',
      uri: 'manage.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'manage.goodeggs.com'
    }
  },
  'manageApi': {
    development: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3010,
      path: '/api'
    },
    test: {
      protocol: 'http',
      uri: 'manage.goodeggs.test',
      port: 3011,
      path: '/api'
    },
    staging: {
      protocol: 'https',
      uri: 'manage.huevosbuenos.com',
      path: '/api'
    },
    production: {
      protocol: 'https',
      uri: 'manage.goodeggs.com',
      path: '/api'
    }
  },
  'kale': {
    development: {
      protocol: 'https',
      uri: 'ops.goodeggs.test',
      port: 8000
    },
    test: {
      protocol: 'http',
      uri: 'ops.goodeggs.test',
      port: 8001
    },
    staging: {
      protocol: 'https',
      uri: 'ops.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops.goodeggs.com'
    }
  },
  'opsEmployeesUi': {
    development: {
      protocol: 'http',
      uri: 'ops-employees.goodeggs.test',
      port: 8005
    },
    test: {
      protocol: 'http',
      uri: 'ops-employees.goodeggs.test',
      port: 8006
    },
    staging: {
      protocol: 'https',
      uri: 'ops-employees.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-employees.goodeggs.com'
    }
  },
  'employeesUi': {
    development: {
      protocol: 'http',
      uri: 'employees.goodeggs.test',
      port: 8005
    },
    test: {
      protocol: 'http',
      uri: 'employees.goodeggs.test',
      port: 8006
    },
    staging: {
      protocol: 'https',
      uri: 'employees.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'employees.goodeggs.com'
    }
  },
  'opsEmployeesApi': {
    development: {
      protocol: 'https',
      uri: 'ops-employees-api.goodeggs.test',
      port: 8010
    },
    test: {
      protocol: 'http',
      uri: 'ops-employees-api.goodeggs.test',
      port: 8011
    },
    staging: {
      protocol: 'https',
      uri: 'ops-employees-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-employees-api.goodeggs.com'
    }
  },
  'employeesApi': {
    development: {
      protocol: 'https',
      uri: 'employees-api.goodeggs.test',
      port: 8010
    },
    test: {
      protocol: 'http',
      uri: 'employees-api.goodeggs.test',
      port: 8011
    },
    staging: {
      protocol: 'https',
      uri: 'employees-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'employees-api.goodeggs.com'
    }
  },
  'opsPurchaseOrdersUi': {
    development: {
      protocol: 'http',
      uri: 'ops-purchase-orders.goodeggs.test',
      port: 8025
    },
    test: {
      protocol: 'http',
      uri: 'ops-purchase-orders.goodeggs.test',
      port: 8026
    },
    staging: {
      protocol: 'https',
      uri: 'ops-purchase-orders.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-purchase-orders.goodeggs.com'
    }
  },
  'purchaseOrdersUi': {
    development: {
      protocol: 'http',
      uri: 'purchase-orders.goodeggs.test',
      port: 8025
    },
    test: {
      protocol: 'http',
      uri: 'purchase-orders.goodeggs.test',
      port: 8026
    },
    staging: {
      protocol: 'https',
      uri: 'purchase-orders.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'purchase-orders.goodeggs.com'
    }
  },
  'opsPurchaseOrdersApi': {
    development: {
      protocol: 'http',
      uri: 'ops-purchase-orders-api.goodeggs.test',
      port: 8030
    },
    test: {
      protocol: 'http',
      uri: 'ops-purchase-orders-api.goodeggs.test',
      port: 8031
    },
    staging: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops-purchase-orders-api.goodeggs.com'
    }
  },
  'purchaseOrdersApi': {
    development: {
      protocol: 'http',
      uri: 'purchase-orders-api.goodeggs.test',
      port: 8030
    },
    test: {
      protocol: 'http',
      uri: 'purchase-orders-api.goodeggs.test',
      port: 8031
    },
    staging: {
      protocol: 'https',
      uri: 'purchase-orders-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'purchase-orders-api.goodeggs.com'
    }
  },
  'opsInventoryApi': {
    development: {
      protocol: 'http',
      uri: 'inventory-api.goodeggs.test',
      port: 8040
    },
    test: {
      protocol: 'http',
      uri: 'inventory-api.goodeggs.test',
      port: 8041
    },
    staging: {
      protocol: 'https',
      uri: 'inventory-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'inventory-api.goodeggs.com'
    }
  },
  'opsInventoryUi': {
    development: {
      protocol: 'http',
      uri: 'inventory.goodeggs.test',
      port: 8045
    },
    test: {
      protocol: 'http',
      uri: 'inventory.goodeggs.test',
      port: 8046
    },
    staging: {
      protocol: 'https',
      uri: 'inventory.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'inventory.goodeggs.com'
    }
  },
  'customersApi': {
    development: {
      protocol: 'http',
      uri: 'customers-api.goodeggs.test',
      port: 8050
    },
    test: {
      protocol: 'http',
      uri: 'customers-api.goodeggs.test',
      port: 8051
    },
    staging: {
      protocol: 'https',
      uri: 'customers-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'customers-api.goodeggs.com'
    }
  },
  'availabilityApi': {
    development: {
      protocol: 'http',
      uri: 'availability-api.goodeggs.test',
      port: 8060
    },
    test: {
      protocol: 'http',
      uri: 'availability-api.goodeggs.test',
      port: 8061
    },
    staging: {
      protocol: 'https',
      uri: 'availability-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'availability-api.goodeggs.com'
    }
  },
  'domainEvents': {
    development: {
      protocol: 'http',
      uri: 'domain-events.goodeggs.test',
      port: 9000
    },
    test: {
      protocol: 'http',
      uri: 'domain-events.goodeggs.test',
      port: 9001
    },
    staging: {
      protocol: 'https',
      uri: 'domain-events.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'domain-events.goodeggs.com'
    }
  },
  'demandPredictionApi': {
    development: {
      protocol: 'http',
      uri: 'demand-prediction-api.goodeggs.test',
      port: 8090
    },
    test: {
      protocol: 'http',
      uri: 'demand-prediction-api.goodeggs.test',
      port: 8091
    },
    staging: {
      protocol: 'https',
      uri: 'demand-prediction-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'demand-prediction-api.goodeggs.com'
    }
  },
  'pickApi': {
    development: {
      protocol: 'http',
      uri: 'pick-api.goodeggs.test',
      port: 9010
    },
    test: {
      protocol: 'http',
      uri: 'pick-api.goodeggs.test',
      port: 9011
    },
    staging: {
      protocol: 'https',
      uri: 'pick-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-api.goodeggs.com'
    }
  },
  'shippingApi': {
    development: {
      protocol: 'http',
      uri: 'shipping-api.goodeggs.test',
      port: 9020
    },
    test: {
      protocol: 'http',
      uri: 'shipping-api.goodeggs.test',
      port: 9021
    },
    staging: {
      protocol: 'https',
      uri: 'shipping-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'shipping-api.goodeggs.com'
    }
  },
  'fulfillmentUi': {
    development: {
      protocol: 'http',
      uri: 'fulfillment.goodeggs.test',
      port: 9030
    },
    test: {
      protocol: 'http',
      uri: 'fulfillment.goodeggs.test',
      port: 9031
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment.goodeggs.com'
    }
  },
  'fulfillmentOptionsApi': {
    development: {
      protocol: 'http',
      uri: 'fulfillment-options-api.goodeggs.test',
      port: 9040
    },
    test: {
      protocol: 'http',
      uri: 'fulfillment-options-api.goodeggs.test',
      port: 9041
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment-options-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment-options-api.goodeggs.com'
    }
  },
  'itAccountsUi': {
    development: {
      protocol: 'http',
      uri: 'it-accounts-ui.goodeggs.test',
      port: 9050
    },
    test: {
      protocol: 'http',
      uri: 'it-accounts-ui.goodeggs.test',
      port: 9051
    },
    staging: {
      protocol: 'https',
      uri: 'it-accounts-ui.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'it-accounts-ui.goodeggs.com'
    }
  },
  'itAccountsApi': {
    development: {
      protocol: 'http',
      uri: 'it-accounts-api.goodeggs.test',
      port: 9060
    },
    test: {
      protocol: 'http',
      uri: 'it-accounts-api.goodeggs.test',
      port: 9061
    },
    staging: {
      protocol: 'https',
      uri: 'it-accounts-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'it-accounts-api.goodeggs.com'
    }
  },
  'pickTriageApi': {
    development: {
      protocol: 'http',
      uri: 'pick-triage-api.goodeggs.test',
      port: 9070
    },
    test: {
      protocol: 'http',
      uri: 'pick-triage-api.goodeggs.test',
      port: 9071
    },
    staging: {
      protocol: 'https',
      uri: 'pick-triage-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-triage-api.goodeggs.com'
    }
  },
  'pickTriageUi': {
    development: {
      protocol: 'http',
      uri: 'pick-triage.goodeggs.test',
      port: 9075
    },
    test: {
      protocol: 'http',
      uri: 'pick-triage.goodeggs.test',
      port: 9076
    },
    staging: {
      protocol: 'https',
      uri: 'pick-triage.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'pick-triage.goodeggs.com'
    }
  },
  'gatherUi': {
    development: {
      protocol: 'http',
      uri: 'gather.goodeggs.test',
      port: 9085
    },
    test: {
      protocol: 'http',
      uri: 'gather.goodeggs.test',
      port: 9086
    },
    staging: {
      protocol: 'https',
      uri: 'gather.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'gather.goodeggs.com'
    }
  },
  'devicesApi': {
    development: {
      protocol: 'http',
      uri: 'devices-api.goodeggs.test',
      port: 9090
    },
    test: {
      protocol: 'http',
      uri: 'devices-api.goodeggs.test',
      port: 9091
    },
    staging: {
      protocol: 'https',
      uri: 'devices-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'devices-api.goodeggs.com'
    }
  },
  'devicesUi': {
    development: {
      protocol: 'http',
      uri: 'devices.goodeggs.test',
      port: 9095
    },
    test: {
      protocol: 'http',
      uri: 'devices.goodeggs.test',
      port: 9096
    },
    staging: {
      protocol: 'https',
      uri: 'devices.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'devices.goodeggs.com'
    }
  },
  'merchandisingUi': {
    development: {
      protocol: 'http',
      uri: 'merchandising.goodeggs.test',
      port: 9100
    },
    test: {
      protocol: 'http',
      uri: 'merchandising.goodeggs.test',
      port: 9101
    },
    staging: {
      protocol: 'https',
      uri: 'merchandising.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'merchandising.goodeggs.com'
    }
  },
  'driveApi': {
    development: {
      protocol: 'https',
      uri: 'drive.goodeggs.test',
      port: 9110
    },
    test: {
      protocol: 'http',
      uri: 'drive.goodeggs.test',
      port: 9111
    },
    staging: {
      protocol: 'https',
      uri: 'drive.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'drive.goodeggs.com'
    }
  },
  'driveUi': {
    development: {
      protocol: 'https',
      uri: 'drive.goodeggs.test',
      port: 9110
    },
    test: {
      protocol: 'http',
      uri: 'drive.goodeggs.test',
      port: 9111
    },
    staging: {
      protocol: 'https',
      uri: 'drive.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'drive.goodeggs.com'
    }
  },
  'fulfillmentOptionsUi': {
    development: {
      protocol: 'http',
      uri: 'fulfillment-options.goodeggs.test',
      port: 9120
    },
    test: {
      protocol: 'http',
      uri: 'fulfillment-options.goodeggs.test',
      port: 9121
    },
    staging: {
      protocol: 'https',
      uri: 'fulfillment-options.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'fulfillment-options.goodeggs.com'
    }
  },
  'catalogApi': {
    development: {
      protocol: 'https',
      uri: 'catalog-api.goodeggs.test',
      port: 9130
    },
    test: {
      protocol: 'http',
      uri: 'catalog-api.goodeggs.test',
      port: 9131
    },
    staging: {
      protocol: 'https',
      uri: 'catalog-api.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'catalog-api.goodeggs.com'
    }
  },
  'login': {
    development: {
      protocol: 'http',
      uri: 'developer-login.goodeggs.test',
      port: 9140
    },
    test: {
      protocol: 'http',
      uri: 'ops.goodeggs.test',
      port: 8001
    },
    staging: {
      protocol: 'https',
      uri: 'ops.huevosbuenos.com'
    },
    production: {
      protocol: 'https',
      uri: 'ops.goodeggs.com'
    }
  }
};

sites.ops = sites.kale;

dasherize = function(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

for (key in sites) {
  sites[dasherize(key)] = sites[key];
}
